"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reactSortableHoc = require("react-sortable-hoc");

var _utils = require("../utils");

var _DragHandle = _interopRequireDefault(require("../DragHandle"));

var _Check = _interopRequireDefault(require("@insided/shared/icons/Check"));

var _Close = _interopRequireDefault(require("@insided/shared/icons/Close"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var ReorderContent = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(ReorderContent, _Component);

  var _super = _createSuper(ReorderContent);

  function ReorderContent() {
    var _this;

    (0, _classCallCheck2.default)(this, ReorderContent);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      tempItems: (0, _toConsumableArray2.default)(_this.props.selectedItems)
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onSortEnd", function (_ref) {
      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;

      _this.setState(function (prevState) {
        return {
          tempItems: (0, _reactSortableHoc.arrayMove)(prevState.tempItems, oldIndex, newIndex)
        };
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleConfirm", function () {
      _this.props.onConfirm(_this.state.tempItems);
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleCancel", function () {
      _this.props.onCancel();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getItemLabel", function (itemId) {
      // Find the item in availableItems by matching ID
      // All items should have names since WidgetSetting.name is required, and syncSelectedItems ensures valid items
      var item = _this.props.availableItems.find(function (item) {
        return (0, _utils.getItemUniqueId)(item) === itemId;
      });

      return (item === null || item === void 0 ? void 0 : item.name) || itemId; // Should always find item, but fallback to ID if not found
    });
    return _this;
  }

  (0, _createClass2.default)(ReorderContent, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.selectedItems !== this.props.selectedItems) {
        this.setState({
          tempItems: (0, _toConsumableArray2.default)(nextProps.selectedItems)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var tempItems = this.state.tempItems;
      return (0, _preact.h)("div", {
        className: "reorder-content"
      }, (0, _preact.h)("div", {
        className: "reorder-content-header"
      }, (0, _preact.h)("span", {
        className: "reorder-content-title"
      }, "Reposition content"), (0, _preact.h)("div", {
        className: "reorder-content-actions"
      }, (0, _preact.h)("button", {
        className: "reorder-content-action-button reorder-content-confirm",
        onClick: this.handleConfirm,
        type: "button",
        "aria-label": "Confirm reorder"
      }, (0, _preact.h)(_Check.default, {
        width: 20,
        height: 20
      })), (0, _preact.h)("button", {
        className: "reorder-content-action-button reorder-content-cancel",
        onClick: this.handleCancel,
        type: "button",
        "aria-label": "Cancel reorder"
      }, (0, _preact.h)(_Close.default, {
        width: 20,
        height: 20
      })))), (0, _preact.h)("div", {
        className: "navigation_links-list"
      }, (0, _preact.h)(_utils.SortableList, {
        useDragHandle: true,
        onSortEnd: this.onSortEnd
      }, tempItems.map(function (itemId, index) {
        return (0, _preact.h)(_utils.SortableItem, {
          key: itemId,
          index: index,
          className: "sortable-navigation-link"
        }, (0, _preact.h)("div", {
          className: "sortable-navigation-links-configurator"
        }, (0, _preact.h)("div", {
          className: "sortable-navigation-links-configurator-title"
        }, (0, _preact.h)("span", {
          className: "sortable-navigation-links-configurator-title-text"
        }, (0, _preact.h)(_DragHandle.default, null), _this2.getItemLabel(itemId)))));
      }))));
    }
  }]);
  return ReorderContent;
}(_preact.Component);

var _default = ReorderContent;
exports.default = _default;